export default __webpack_public_path__ + "static/media/screen-be-the-hero.6344250b.png";